import styled from "styled-components";
import { breakpoints } from "@theme/breakpoints";

const StyledWrapper = styled.div<{ $height: number }>`
  width: 90%;
  max-width: 1400px;
  border-radius: 32px;
  display: flex;
  margin: ${({ $height }) => -Math.round($height / 2) + 145}px auto 0;
  padding: 70px min(5%, 70px);
  border: 1px solid ${({ theme }) => theme.washLight};
  background: #fbfafa;
  position: relative;
  z-index: 1;
  overflow: hidden;
  isolation: isolate;
  gap: 60px;
  justify-content: space-between;
  transform: translateY(50%);

  ${breakpoints.laptopMax`
    padding: 56px min(5%, 56px);
    flex-direction: column;
    gap: 30px;
    max-width: 910px;
  `};

  ${breakpoints.tabletMax`
    margin-top: ${({ $height }: any) => -Math.round($height / 2) + 90}px;
  `}

  ${breakpoints.phoneMax`
    padding: 32px min(5%, 32px);
    border-radius: 24px;
    width: 100%;
    text-align: center;
    gap: 20px;
    margin-top: 60px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    transform: translateY(0);
  `};

  &::before {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    content: "";
    box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.25);
    border-radius: 32px;
    pointer-events: none;

    ${breakpoints.phoneMax`
      border-radius: 24px;
      box-shadow: none;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    `};
  }
`;

const StyledLeftWrapper = styled.div`
  max-width: 853px;
  flex: 1;
`;

const StyledHeading = styled.h2`
  font-size: 4.8rem;
  margin: 0 0 32px;

  span {
    color: ${({ theme }) => theme.primary};
  }

  ${breakpoints.laptopMax`
    font-size: 3.6rem;
    margin: 0 0 24px;
  `};

  ${breakpoints.phoneMax`
    font-size: 2.4rem;
    margin: 0 0 16px;
  `};
`;

const StyledDescription = styled.p`
  margin: 0;
  line-height: 1.6;
  font-size: 2.4rem;

  b,
  strong {
    font-weight: 600;
  }

  ${breakpoints.laptopMax`
    font-size: 2rem;
  `};

  ${breakpoints.phoneMax`
    font-size: 1.6rem;
  `};
`;

const StyledImageWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  pointer-events: none;
  user-select: none;

  > * {
    width: 100%;
    height: 100%;
    pointer-events: none;
    user-select: none;
  }
`;

const StyledDesktopImageWrapper = styled(StyledImageWrapper)`
  ${breakpoints.tabletMax`
    display: none;
  `}
`;

const StyledLaptopImageWrapper = styled(StyledImageWrapper)`
  display: none;

  ${breakpoints.tabletMax`
    display: block;
  `};
`;

const StyledMobileImageWrapper = styled(StyledImageWrapper)`
  display: none;

  ${breakpoints.phoneMax`
    display: block;
  `};
`;

export {
  StyledWrapper,
  StyledLeftWrapper,
  StyledHeading,
  StyledDescription,
  StyledDesktopImageWrapper,
  StyledLaptopImageWrapper,
  StyledMobileImageWrapper,
};
